/**
 * Theme control (§18) — a System / Light / Dark segmented control in the shell.
 * System is the default and tracks prefers-color-scheme; explicit choices persist
 * via the ThemeProvider. The user can return to System.
 */
import { useTheme, type ThemeMode } from "../../lib/theme.js";
import { Icon, type IconName } from "./Icon.js";

const OPTIONS: Array<{ mode: ThemeMode; icon: IconName; label: string }> = [
  { mode: "system", icon: "contrast", label: "System" },
  { mode: "light", icon: "sun", label: "Light" },
  { mode: "dark", icon: "moon", label: "Dark" },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  return (
    <div className="theme-seg" role="group" aria-label="Theme">
      {OPTIONS.map((o) => (
        <button
          key={o.mode}
          type="button"
          className={"theme-seg__btn" + (mode === o.mode ? " theme-seg__btn--active" : "")}
          aria-pressed={mode === o.mode}
          title={`${o.label} theme`}
          onClick={() => setMode(o.mode)}
        >
          <Icon name={o.icon} size={14} />
          <span className="theme-seg__label">{o.label}</span>
        </button>
      ))}
    </div>
  );
}
